import { Component, OnInit } from '@angular/core';

import { EnabledAppFacade } from '@app/core/facades/enabled-app.facade';
import FilterChange from '@app/shared/filters/filter-change.model';
import { FilterType } from '@app/shared/components/sub-header/filter-type.model';
import FilterComponent from '@app/shared/filters/filter.component';

const SIZE = '180px';

@Component({
  selector: 'app-filter-course',
  templateUrl: '../filter.component.html',
  styleUrls: ['../filter.component.scss'],
})
export default class CourseFilterComponent extends FilterComponent implements OnInit {
  public readonly width = SIZE;
  public readonly label = 'Course';

  public readonly hasLogo = false;

  constructor(private readonly _data: EnabledAppFacade) {
    super();
  }

  public update(value: string, _: boolean): void {
    this._data.updateCourseId(value);
    this.valueChange.emit(new FilterChange(FilterType.Course, value));
  }

  ngOnInit() {
    this.init(this._data.courseId$, this._data.coursesFiltered$, this._data.coursesFiltered$);
  }
}
